/**
 * Returns a new ordered list with the matched item replaced while preserving original order.
 * @param updatedData Updated record containing at least Id/PaginationToken shape.
 * @param dataList Existing ordered list of records.
 * @returns New ordered list with the matched item replaced; unchanged list if no match.
 */
export const updateDataListOrdered = <T extends { Id: string, PaginationToken?: string | null }>(updatedData: T, dataList: Array<T>): Array<T> => {
    if (!updatedData) {
        return dataList;
    }

    if (dataList?.length === 0) {
        return [];
    }

    const id: string = updatedData?.Id ?? "";

    const existingProductIndex = dataList.findIndex(data => data.Id === id);
    if (existingProductIndex === -1) {
        return dataList;
    }

    const preOrderedProducts = dataList.slice(0, existingProductIndex);
    const postOrderedProducts = dataList.slice(existingProductIndex + 1);
    const updatedProductData = {
        ...updatedData,
        PaginationToken: dataList[existingProductIndex]?.PaginationToken
    };

    return [
        ...preOrderedProducts,
        updatedProductData,
        ...postOrderedProducts
    ];
};